import { motion } from "framer-motion";
import { HardDrive, Monitor, Cpu } from "lucide-react";

const specs = [
  { cat: "System Requirements", icon: HardDrive, items: [{ l: "OS", v: "Windows 10 / 11 (64-bit)" }, { l: "Simulator", v: "Prepar3D v4, v5, v6" }, { l: "Display", v: "Multi-display configuration" }, { l: "Architecture", v: "x64 only" }] },
  { cat: "Simulated Panels", icon: Monitor, items: [{ l: "Display Panels", v: "PFD, MFD, PFD2" }, { l: "Control Panels", v: "Audio Panel, Autopilot Controller, Keypad" }, { l: "Avionics", v: "ADC, AHRS & Magnetometer" }, { l: "Radio Nav", v: "VHF-NAV/LOC/GS, DME, ADF" }] },
  { cat: "Navigation Systems", icon: Cpu, items: [{ l: "GPS", v: "SBAS-enabled GPS" }, { l: "Transponder", v: "XPDR simulation" }, { l: "Pitot-Static", v: "Full system simulation" }, { l: "Autopilot", v: "AFCS with failure modes" }] },
];

export function SpecsSection() {
  return (
    <section id="specs" className="py-24">
      <div className="container mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 280, damping: 32 }} className="mb-12">
          <p className="text-xs font-mono tracking-[0.25em] uppercase font-bold mb-2" style={{ color: "oklch(0.55 0.22 25)" }}>— Technical Specifications —</p>
          <h2 className="text-4xl md:text-5xl font-black text-foreground" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            System <span style={{ color: "oklch(0.28 0.09 240)" }}>Specs</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-10">
          {specs.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div key={s.cat} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ delay: i * 0.1, type: "spring", stiffness: 280, damping: 32 }}
                className="bg-white rounded-xl border border-border p-6 shadow-[0_2px_12px_oklch(0.12_0.03_240/0.06)]"
                style={{ borderTop: "3px solid oklch(0.28 0.09 240)" }}>
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center">
                    <Icon className="w-4 h-4 text-primary" />
                  </div>
                  <h3 className="font-bold text-sm text-foreground">{s.cat}</h3>
                </div>
                <div className="space-y-3">
                  {s.items.map(item => (
                    <div key={item.l} className="flex justify-between items-start gap-4 border-b border-border/60 pb-3 last:border-none last:pb-0">
                      <span className="text-xs text-muted-foreground font-mono">{item.l}</span>
                      <span className="text-xs text-foreground font-medium text-right">{item.v}</span>
                    </div>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* Certs */}
        <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ type: "spring", stiffness: 280, damping: 32 }}
          className="rounded-xl border-2 border-primary/20 bg-primary/5 p-6">
          <p className="text-center text-xs font-mono tracking-[0.2em] uppercase font-bold text-primary mb-5">Certification Compatibility</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            {[{ l: "FAA", d: "Part 121 / 135 compatible" }, { l: "EASA", d: "FCL / OPS compliant" }, { l: "Custom", d: "Any authority labeling" }].map(c => (
              <div key={c.l} className="flex-1 max-w-xs mx-auto sm:mx-0 bg-white rounded-lg border border-border p-4 text-center shadow-sm">
                <span className="block text-2xl font-black text-foreground mb-1" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{c.l}</span>
                <span className="text-xs text-muted-foreground">{c.d}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
